import React from 'react';
import './Portfolio.css';


export function Portfolio() {


    return (
        <section id="portfolio">
            <header id="portfolio-header">Work in progress...</header>
        </section>
    )

}